const atcBtn = document.querySelector("buy-buttons button[type='submit']");
const disableAtcBtn = () => {
  atcBtn.disabled = true;
  atcBtn.setAttribute("aria-disabled", "true");
  atcBtn.setAttribute("aria-label", "Please select a size");
  atcBtn.setAttribute("tabindex", "-1");
  atcBtn.classList.add("hc-size-not-selected");
  atcBtn.innerHTML = window.themeVariables.strings.selectSizeButton;
};
const updateSizeSelection = (product, variant, previousVariant) => {
  return;
  /**
  const sizeIndex = product.options.findIndex(
    (option) => option.name.toLowerCase() === "size",
  );
  // Find the options indices that have changed
  const changedOptions = variant.options.reduce((changed, option, index) => {
    if (option !== previousVariant.options[index]) {
      changed.push(index);
    }
    return changed;
  }, []);
  // if only size has changed early return
  if (changedOptions.length === 1 && changedOptions[0] === sizeIndex) {
    atcBtn.classList.remove("hc-size-not-selected");
    return false;
  }
  // otherwise unselect the size
  const sizeSelect = document.querySelector(
    `.variant-picker__option-values input[name="option${
      sizeIndex + 1
    }"]:checked`,
  );
  if (sizeSelect) {
    sizeSelect.checked = false;
    disableAtcBtn();
  }
  return true;
  **/
};
document.addEventListener("variant:change", (event) => {
  const { variant, previousVariant, product } = event.detail;
  const isNoSize =
    [...document.querySelectorAll(".product-info .block-swatch--size")]
      .map((elem) =>
        elem.parentElement.querySelector(`#${elem.getAttribute("for")}`),
      )
      .filter((inp) => inp.checked).length === 0;
  // find size option
  setTimeout(() => {
    document.body.classList.toggle("hc--hide-klaviyo-bis", isNoSize);
    const soldoutMessage = document.querySelector(".hc-soldout-message");
    if (isNoSize) {
      soldoutMessage.innerHTML = "";
      return;
    }
    const messages = JSON.parse(soldoutMessage.dataset.messages);
    const message = messages.find(([id]) => id === variant.id);
    if (message[1] && variant.available === false) {
      soldoutMessage.innerHTML = message[1];
      soldoutMessage.classList.add("hc-soldout-message--visible");
    } else {
      soldoutMessage.innerHTML = "";
      soldoutMessage.classList.remove("hc-soldout-message--visible");
    }
  });
});

const lastOption = document.querySelector(
  ".variant-picker__option:last-of-type",
);
if (lastOption) {
  // Find the checked size
  const checkedSize = lastOption.querySelector("input:checked");
  if (checkedSize) {
    checkedSize.checked = false;
    if (
      document.querySelectorAll(".product-info [data-option-selector]").length >
      1
    ) {
      disableAtcBtn();
    }
  }
}

class StickyAtcContainer {
  /**
   * @param {HTMLElement} el
   * @param {Object} options
   * @param {string} options.headerSelector
   */
  constructor(el, options) {
    this.header = options.headerSelector
      ? document.querySelector(options.headerSelector)
      : document.querySelector(".header, header");

    this.stickyElement = el;

    this.initializeObserver();
  }

  initializeObserver() {
    const isMobile = window.matchMedia("(max-width: 767px)").matches;

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting || entry.boundingClientRect.y > 0) {
        this.stickyElement.classList.remove("hc__is-sticky-atc");
      } else {
          this.stickyElement.classList.add("hc__is-sticky-atc");
      }
    });

    if (!isMobile) {
      window.addEventListener("resize", () => {
        if (!window.matchMedia("(max-width: 767px)").matches) {
          observer.disconnect();
          this.stickyElement.classList.remove("hc__is-sticky-atc");
          return;
        }
        observer.observe(this.stickyElement);
      });
      return;
    }
    return observer.observe(this.stickyElement);
  }
}

class HCStickyBuyButtons extends HTMLElement {
  variantOptions = [];
  isSizeSelected = false;

  constructor() {
    super();
    this.createAtcButton();
  }

  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;


    document.addEventListener("variant:change", (event) => {
      const { variant, previousVariant, product, preOrderData } = event.detail;
      this.updateVariant(product, variant, previousVariant, preOrderData);
    });


    this.variantPickers = [...this.closest('.product-info').querySelectorAll('.variant-picker__option')];
  }

  createAtcButton() {
    this.atcButton = this.closest(".product-info__block-item").querySelector("button[type='submit']").cloneNode(true);
    this.atcButton.classList.add("hc-sticky-atc-button");
    this.atcButton.setAttribute("type", "button");
    this.append(this.atcButton);
    this.atcButton.disabled = false;
    this.atcButton.addEventListener("click", () => {
      this.onAtcButtonClick();
    })
    this.atcButton.addEventListener("touchmove", (event) => {
      event.preventDefault();
    });
    this.atcButton.addEventListener("touchstart", (event) => {
      event.stopPropagation();
    });
    this.atcButton.addEventListener("touchend", (event) => {
      event.preventDefault();
      this.onAtcButtonClick();
    });

    this._atcButtonText = document.createElement("span");
    this._atcButtonText.classList.add("hc-sticky-atc-button__text");
    this._atcButtonText.innerHTML = this.atcButton.innerHTML;
    this.atcButton.innerHTML = "";
    this.atcButton.append(this._atcButtonText);

    const atcButtonSeparator = document.createElement("span");
    atcButtonSeparator.classList.add("hc-sticky-atc-button__separator");
    atcButtonSeparator.innerHTML = "•";
    this.atcButton.append(atcButtonSeparator);

    this._atcButtonPriceText = document.createElement("span");
    this._atcButtonPriceText.classList.add("hc-sticky-atc-button__price");
    this.atcButton.append(this._atcButtonPriceText);
  }

  /** @param {number | null} price */
  set atcButtonPriceText(price) {
    if (price === null || !this.isSizeSelected) {
      this._atcButtonPriceText.innerHTML = "";
      return;
    }
    if (price == 0) {
      this._atcButtonPriceText.innerHTML = window.themeVariables.strings.selectANewOption;
      return;
    }
    const currencyFormat = window.themeVariables.settings.currencyCodeEnabled
      ? window.themeVariables.settings.moneyWithCurrencyFormat
      : window.themeVariables.settings.moneyFormat;
    
    this._atcButtonPriceText.innerHTML = window.formatMoney(price, currencyFormat);
  }

  /** @param {string} text */
  set atcButtonText(text) {
    this._atcButtonText.innerHTML = text;
  }

  /** @param {boolean} disabled */
  set atcButtonDisabled(disabled) {
    if (disabled) {
      this.atcButton.setAttribute("aria-disabled", "true");
      this.atcButton.setAttribute("aria-label", "Sold out");
      this.atcButton.setAttribute("tabindex", "-1");
      this.atcButton.classList.remove("hc-size-not-selected");
    } else {
      this.atcButton.removeAttribute("aria-disabled");
      this.atcButton.removeAttribute("aria-label");
      this.atcButton.setAttribute("tabindex", "0");
    }
  }

  /** @param {boolean} isSelected */
  set atcButtonSizeSelected(isSelected) {
    if (isSelected) {
      this.atcButton.removeAttribute("aria-label");
      this.atcButton.setAttribute("tabindex", "0");
      this.atcButton.classList.remove("hc-size-not-selected");
      this.atcButtonText = window.themeVariables.strings.addToCartButton;
    } else {
      this.atcButton.setAttribute("aria-label", "Please select a size");
      this.atcButton.setAttribute("tabindex", "-1");
      this.atcButton.classList.add("hc-size-not-selected");
      this.atcButtonText = window.themeVariables.strings.selectSizeButton;
    }
  }
    

  updateVariant(product, variant, previousVariant, preOrderData) {
    const variantValues = this.variantPickers.map((option) => option.querySelector('input:checked')?.nextElementSibling);
    const sizeOptionIndex = product.options.findIndex(
      (option) => option.name.toLowerCase() === "size",
    );
    const sizeValue = variantValues[sizeOptionIndex];
    this.isSizeSelected = !!sizeValue;
    this.isSoldout = !variant.available;

    this.updateAtcButton(variant);

    if (this.isSizeSelected) {
      const variantData = preOrderData?.get(variant.id);
      const isPreOrder = variantData?.quantity <= 0 && variantData?.inventory_management === "shopify" && variantData?.inventory_policy === "continue";
      this.atcButton.classList.toggle("hc-pre-order", isPreOrder);
    } else {
      this.atcButton.classList.remove("hc-pre-order");
    }

    this.atcButtonPriceText = variant.available ? variant.price : 0;

  }

  updateAtcButton(variant) {
    this.atcButtonSizeSelected = this.isSizeSelected;
    if (this.isSizeSelected) {
      if (!variant.available) {
        this.atcButtonDisabled = true;
        this.atcButtonText = window.themeVariables.strings.soldOutButton;
        return;
      }

      this.atcButtonDisabled = false;
      this.atcbuttonsizeselected = this.issizeselected;

      // Copy the og button innerHTML
      setTimeout(() => {
        this.atcButtonText = this.closest('.product-info').querySelector("button[type='submit']").innerHTML;
      });

    }  
  }

  onAtcButtonClick() {
    if (this.isSizeSelected && !this.isSoldout) {
      this.closest('.product-info').querySelector("button[type='submit']").click();
    } else {
      this.scrollToVariantPickers();
    }
  }

  scrollToVariantPickers() {
    this.variantPickers[0].scrollIntoView({ behavior: "smooth" });
  }
}

customElements.define("hc-sticky-buy-buttons", HCStickyBuyButtons);

window.addEventListener("DOMContentLoaded", () => {
  window.stickyAtcContainer = new StickyAtcContainer(
    document.querySelector(
      '.product-info__block-item[data-block-type="buy-buttons"]',
    ),
    {
      headerSelector: ".header",
    },
  );
});

function updateUniformWidth() {
  const boxes = document.querySelectorAll('.variant-picker__option-values .block-swatch.block-swatch--size span');
  let maxWidth = 35;
  
  boxes.forEach(box => {
    maxWidth = Math.max(maxWidth, box.offsetWidth);
  });
  
  document.documentElement.style.setProperty('--swatch-uniform-width', `${maxWidth}px`);
}

window.addEventListener('load', updateUniformWidth);
window.addEventListener('resize', updateUniformWidth);

